export const colors = {
  primary: "#160E28", //updated
  primaryDark: "#301E56", //updated
  primaryLight: "#557DA5",
  secondary: "#FFB000", //updated
  secondaryLight: "rgba(255, 176, 0, 0.4)",
  tertiary: "#171731", //updated
  tertiaryDark: "#483B3B",
  quaternary: "#C7C7C7", //updated
  secondaryBackground: "#2c4155",
  cardBack: "#273F56",
  secondaryText: "#E83939",
  cardRed: "#ED6060",
  cardBlack: "#443C3C",
  cardWhite: "#ffffff",
  closeStrokeColor: "#3D6389",
  tetriaryBackground: "#38433D",
}
